import React, { useState } from "react";
import ReportSelector from "../components/common/ReportSelector";
import PurchaseReports from "../components/purchase/PurchaseReports";
import SalesReports from "../components/sales/SalesReport";
import Server from "../api/Server";
import moment from "moment";
import notify from "devextreme/ui/notify";
import { packagingReportformData } from "../App";
import Title from "../components/common/Title";

const options = {
  PURCHASE: "Purchase",
  SALES: "Sales",
};

const PackagingReport = () => {
  const [reportStore, setReportStore] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState("");

  const fetchReport = () => {
    setReportStore(null);
    if (packagingReportformData.reportType === options.PURCHASE) {
      setIsLoading(true);
      setType(packagingReportformData.reportType);
      const startDate = moment(packagingReportformData.startDate).format(
        "YYYY-MM-DD"
      );
      const endDate = moment(packagingReportformData.endDate).format(
        "YYYY-MM-DD"
      );
      Server.getPurchaseReport(startDate, endDate)
        .then((res) => {
          //   console.log(res);

          setReportStore(res.data.data);
          setIsLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            const {
              response: { data },
            } = err;
            if (data) {
              notify(`${data.status.errorDescription}`, "error", 3000);
            } else {
              notify(
                "Error getting reports data, please try again",
                "error",
                3000
              );
            }
          } else {
            notify(
              "Error getting reports data, please try again",
              "error",
              3000
            );
          }
          setIsLoading(false);
          setReportStore([]);
        });
    }

    if (packagingReportformData.reportType === options.SALES) {
      setIsLoading(true);
      setType(packagingReportformData.reportType);
      const startDate = moment(packagingReportformData.startDate).format(
        "YYYY-MM-DD"
      );
      const endDate = moment(packagingReportformData.endDate).format(
        "YYYY-MM-DD"
      );
      Server.getSalesReport(startDate, endDate)
        .then((res) => {
          //   console.log(res);
          setReportStore(res.data.data);
          setIsLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            const {
              response: { data },
            } = err;
            if (data) {
              notify(`${data.status.errorDescription}`, "error", 3000);
            } else {
              notify(
                "Error getting reports data, please try again",
                "error",
                3000
              );
            }
          } else {
            notify(
              "Error getting reports data, please try again",
              "error",
              3000
            );
          }

          setIsLoading(false);
          setReportStore([]);
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchReport();
  };

  return (
    <section>
      <Title pageTitle={"Packaging materials reports"} />
      <ReportSelector
        formData={packagingReportformData}
        handleSubmit={handleSubmit}
      />
      {type === options.PURCHASE && (
        <PurchaseReports reportsStore={reportStore} isLoading={isLoading} />
      )}
      {type === options.SALES && (
        <SalesReports reportsStore={reportStore} isLoading={isLoading} />
      )}
    </section>
  );
};

export default PackagingReport;
